import { ReactiveVar, makeVar } from '@apollo/client'

import { IRole } from 'shared/interfaces'

import { getFiltersFromLocalStorage } from 'shared/utils/filters'
import { USERS_FILTER_STORAGE_NAME, USER_FILTER_INIT_VALUES } from 'shared/consts/filter'

export const UsersStore = {
  usersFilters: {
    read: () => usersFiltersVar()
  },
  internalDomains: {
    read: () => internalDomainsVar()
  },
  userProjectsSearchResult: {
    read: () => userProjectsSearchResultVar()
  }
}

export const userRolesVar: ReactiveVar<IRole[]> = makeVar<IRole[]>([])
export const usersFiltersVar: ReactiveVar<any> = makeVar<any>(
  getFiltersFromLocalStorage(USERS_FILTER_STORAGE_NAME, USER_FILTER_INIT_VALUES)
)
export const internalDomainsVar: ReactiveVar<string[]> = makeVar<string[]>([])
export const userProjectsSearchResultVar: ReactiveVar<any> = makeVar<any>([])
